import { render, staticRenderFns } from "./parametrages-globaux.html?vue&type=template&id=a8bad90c&scoped=true&external"
import script from "./parametrages-globaux.js?vue&type=script&lang=js&external"
export * from "./parametrages-globaux.js?vue&type=script&lang=js&external"
import style0 from "./parametrages-globaux.scss?vue&type=style&index=0&id=a8bad90c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bad90c",
  null
  
)

export default component.exports